<template>
    <div>
        <p v-for="product in products"> {{ product.name }} - <strong>{{ product.price }} Kn</strong>
        </p>
        <h4>Ukupno: {{ parseFloat(total_hrk()).toFixed(2) }} kn</h4>
        <h4>Ukupno: {{ parseFloat(total_usd()).toFixed(2) }} usd</h4>
        <h4>Ukupno: {{ parseFloat(total_eur()).toFixed(2) }} eur</h4>
    </div>
</template>

<script>
    export default {

        props: ['products'],

        data() {
            return {
            }
        },

        methods: {
            total_hrk() {
                return this.products.reduce(function (total, item) {
                    return total + item.prices[0].price_hrk
                }, 0);
            },

            total_usd() {
                return this.products.reduce(function (total, item) {
                    return total + item.prices[0].price_usd
                }, 0);
            },

            total_eur() {
                return this.products.reduce(function (total, item) {
                    return total + item.prices[0].price_eur
                }, 0);
            }

        }
    }
</script>